import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { Stack, Box, Button, Step, StepLabel, Stepper } from '@mui/material';
import React from 'react'
import { siteLogos, sportLogos } from '../utils/logos';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { SitesResponse, SlateResponse } from '../common/store/types';
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    settingsLabelWrapper: {
        backgroundColor: "rgba(219, 77, 0, 0.20)",
        alignItems: 'center',
        borderRadius: '10px'
    },
    settingsText: {
        fontSize: 20,
        fontWeight: 700,
        fontFamily: 'Inter',
    },
    stepperWrapper: {
        backgroundColor: "transparent",
        borderRadius: "3px 3px 0px 0px",
        color: 'white',
        padding: 12,
        flex: 1,
        '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
            color: 'rgba(255, 255, 255, 0.60)',
            fontSize: 14,
        },
        '& .MuiStepIcon-root': {
            color: 'rgba(255, 255, 255, 0.38)'
        },
        '& .MuiStepIcon-completed': {
            color: '#009C06',
        },
        '& .MuiStepIcon-active': {
            color: '#0058CC',
        }
    },
    restart: {
        borderRadius: 3,
        wdith: 80,
        height: 40,
        border: '1px solid rgba(255, 255, 255, 0.20)',
        color: 'white',
        padding: '8px 16px',
        marginLeft: 8,
        textTransform: 'none',
        '&:disabled': {
          backgroundColor: '#555555 !important',
          color: '#BEBEBE'
        }
      },
  })
);


interface OwnProps {
    activeStep: number;
    setActiveStep: (newStep: number) => void;
    setFileUploaded: (uploaded: boolean) => void;
}

interface ReduxProps {
    readonly selectedSlate: SlateResponse;
    readonly selectedSite: SitesResponse;
}
  
type Props = OwnProps & ReduxProps;

const steps = ['Upload Entry File', 'Generate New Contest Pool', 'Review Projections', 'Simulate  Lineups', 'View Results & Export'];
  

const StepsTracker = (props: Props) => {
    const { selectedSlate, selectedSite, activeStep, setActiveStep, setFileUploaded } = props;
    const classes = useStyles();
    const routeParams = useParams<{ league: string }>();
    const league = routeParams.league?.toUpperCase() || 'NBA';

    return (
        <Stack direction={'row'} className={classes.settingsLabelWrapper} paddingX={2}>
            <Stack direction='row' flexWrap='wrap' alignItems="center" spacing={1}>
                <Stack direction='column' >
                    <Box fontSize="12px" marginBottom="8px" style={{ opacity: 0.7 }}>League</Box>
                    <Stack direction="row" className={classes.settingsText}>
                        {league}
                        <Box height="24px" marginLeft="2px">
                            <img src={sportLogos[league?.trim()].logo} alt={sportLogos[league?.trim()].name} style={{ height: '100%', objectFit: 'contain' }} />
                        </Box>
                    </Stack>
                </Stack>
                <Stack direction='column'>
                    <Box fontSize="12px" marginBottom="8px" style={{ opacity: 0.7 }}>Site</Box>
                    <Stack direction="row" className={classes.settingsText}>
                        {selectedSite.site}
                        <Box height="24px" marginLeft="4px">
                            <img src={siteLogos[selectedSite.site?.toLowerCase()].logo} alt={siteLogos[selectedSite.site?.toLowerCase()].logo} style={{ height: '100%', objectFit: 'contain' }} />
                        </Box>
                    </Stack>
                </Stack>
                <Stack direction='column'>
                    <Box fontSize="12px" marginBottom="8px" style={{ opacity: 0.7 }}>Slate</Box>
                    <Stack direction="row" className={classes.settingsText}>
                        {selectedSlate.name}
                        <Stack fontSize="14px" marginLeft="4px" direction="row" alignItems="center">
                            ({new Date(selectedSlate.startTime).toLocaleDateString([], { month: 'short', day: '2-digit', timeStyle: undefined })} - {new Date(selectedSlate.startTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} EST)
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
            <Stepper activeStep={activeStep} alternativeLabel className={classes.stepperWrapper}>
                {steps.map((label, stepIndex) => (
                    <Step key={label} onClick={() => [1, 4].indexOf(stepIndex) > -1 && setActiveStep(stepIndex)}>
                        <StepLabel style={{ cursor: [1, 4].indexOf(stepIndex) > -1 ? 'pointer' : '' }}>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>
            <Button variant={'outlined'} size='small' className={classes.restart} onClick={() => {
                setFileUploaded(false)
                setActiveStep(1);
                }}>
                Restart
            </Button>
      </Stack>
    )
}

const mapStateToProps = (state: any) => {
    const {
      selectedSlate,
      selectedSite,
    } = state.common;
  
    return {
      selectedSite,
      selectedSlate,
    };
  };
  
  const mapDispatchToProps = {
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(StepsTracker);